import { useApp } from '../../context/AppContext';
import { STEPS } from '../../data/content';
import { Icons, type IconName } from '../ui/Icons';
import { Reveal } from '../ui/Reveal';

export function HowItWorks() {
  const { openLeadForm } = useApp();

  return (
    <section id="how" className="relative bg-mist py-20 sm:py-28">
      <div className="container-rosa">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="eyebrow">How Rosa works</p>
          <h2 className="mt-3 font-display text-4xl font-bold leading-[1.08] tracking-[-0.01em] text-plum sm:text-5xl">
            Three steps. One trusted specialist.
          </h2>
          <p className="mt-4 font-body text-lg leading-relaxed text-plum/70">
            No account to make, nothing to pay. You tell Rosa what happened, and the right person calls
            you back prepared.
          </p>
        </Reveal>

        {/* Steps */}
        <div className="relative mt-16">
          {/* Desktop horizontal connector */}
          <div
            className="pointer-events-none absolute left-0 right-0 top-11 hidden lg:block"
            aria-hidden="true"
          >
            <div className="mx-[16.66%] h-px border-t-2 border-dashed border-terracotta/30" />
          </div>

          <ol className="grid gap-12 lg:grid-cols-3 lg:gap-8">
            {STEPS.map((step, i) => {
              const I = Icons[step.icon as IconName];
              return (
                <Reveal
                  as="li"
                  key={step.n}
                  delay={i * 0.12}
                  className="relative flex flex-col items-center text-center lg:px-4"
                >
                  {/* Mobile vertical connector */}
                  {i < STEPS.length - 1 && (
                    <span
                      className="pointer-events-none absolute left-1/2 top-24 h-12 w-px -translate-x-1/2 border-l-2 border-dashed border-terracotta/30 lg:hidden"
                      aria-hidden="true"
                    />
                  )}

                  {/* Numbered node */}
                  <div className="relative">
                    <span className="relative grid h-[5.5rem] w-[5.5rem] place-items-center rounded-full bg-white font-display text-3xl font-bold text-terracotta shadow-lift ring-2 ring-terracotta/40">
                      {step.n}
                    </span>
                    {/* Icon chip */}
                    <span className="absolute -bottom-1 -right-1 grid h-11 w-11 place-items-center rounded-full border border-stone bg-blush text-sage-deep shadow-soft">
                      <I width={22} height={22} />
                    </span>
                  </div>

                  <h3 className="mt-7 font-display text-xl font-semibold text-plum">{step.title}</h3>
                  <p className="mt-3 max-w-xs font-body leading-relaxed text-plum/70">{step.body}</p>
                </Reveal>
              );
            })}
          </ol>
        </div>

        {/* CTA */}
        <Reveal delay={0.15} className="mt-16 flex flex-col items-center">
          <button onClick={() => openLeadForm()} className="btn-primary">
            Get a free safety assessment
            <Icons.arrowRight width={18} height={18} />
          </button>
          <p className="mt-3 font-body text-sm text-plum/60">
            Free, no obligation, usually within 48 hours.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
